import React from "react";
import { IconRocket } from "@tabler/icons-react";

const WelcomeStep = ({ userName }) => {
  const displayName = userName || "usuário";

  return (
    <>
      <div className="onb-card__header onb-card__header--with-icon">
        <div className="onb-card__icon">
          <IconRocket size={28} />
        </div>
        <h2 className="onb-card__title">
          Bem-vindo, {displayName}!
        </h2>
        <p className="onb-card__subtitle">
          Estamos felizes em ter você na plataforma
        </p>
      </div>

      <div className="onb-card__body">
        <p className="onb-card__text">
          Antes de começar, vamos te apresentar as funcionalidades essenciais
          da plataforma. São apenas <strong>2 minutos</strong> e vai fazer
          toda a diferença na sua experiência.
        </p>
        <p className="onb-card__text">
          Este guia rápido vai te mostrar onde encontrar tudo o que precisa
          para criar e gerenciar seus agentes de IA com sucesso.
        </p>
      </div>
    </>
  );
};

export default WelcomeStep;
